import { render } from "./AiSettingsPage.vue?vue&type=template&id=bdacdcda&scoped=true"
import script from "./AiSettingsPage.vue?vue&type=script&lang=js"
export * from "./AiSettingsPage.vue?vue&type=script&lang=js"

import "./AiSettingsPage.vue?vue&type=style&index=0&id=bdacdcda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdacdcda"]])

export default __exports__